import { parse } from 'tldjs'
import tlds from './tlds'

export const getValidationMessages = (validationRules, properties) => {
  return validationRules.reduce((arr, rule) => {
    if (!isValid(rule, properties[rule['property']])) {
      arr.push(rule['message'])
    }
    return arr
  }, [])
}

export const isValid = (validationRule, property) => validationRule.isValid(property)

export const areAllValid = (validationRules, properties) => {
  return validationRules.every(rule => {
    return isValid(rule, properties[rule['property']])
  })
}

export const tldExisits = tld => !!tld?.length && tlds.indexOf(tld.toUpperCase()) !== -1

export const isDomainValid = domain => {
  const parsed = parse(domain)
  const urlValid =
    !!parsed.domain && parsed.isValid && (parsed.tldExists || tldExisits(parsed.publicSuffix))
  return !!domain?.length && urlValid
}

export const isURLValid = string => {
  let url
  try {
    url = new URL(string)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}